// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import { Message, MessageBox,Loading } from 'element-ui';
import storage from './plugins/storage'
import 'element-ui/lib/theme-chalk/index.css'
import * as filters from './filters'
import 'normalize.css'
import { Base64 } from 'js-base64'
import config from "./config";
import VueCookies from 'vue-cookie'
import '../src/common/index.css'
import 'vue-area-linkage/dist/index.css'
import VueParticles from 'vue-particles'
import VueAreaLinkage from 'vue-area-linkage'
import animated from 'animate.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import msgModal from './components/msgModal/modal';
import slideVerify from "vue-monoplasty-slide-verify";



Vue.use(Vant);
Vue.use(ElementUI)
Vue.use(VueAxios, axios)
Vue.use(VueCookies)
Vue.use(VueParticles)
Vue.use(VueAreaLinkage)
Vue.use(animated)
Vue.use(slideVerify);



Vue.config.devtools = !(process.env.NODE_ENV === 'production' && process.env.RUN_ENV === 'production'); // 除正式环境外开启devtools
Vue.config.productionTip = false
Vue.prototype.$loading = Loading.service;
Vue.prototype.storage = storage;
Vue.prototype.$msgModal = msgModal;

//实例化Vue的filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

//axios拦截器
axios.interceptors.request.use(
  config => {
    if (config.params) {
      if (config.method === 'get' && config.params.begin) {
        var http = (window / location.protocol === 'http:' ? 'http:' : 'https');
        return config
      }
    }
    if (!config.url.startsWith('http')) {
      let _web_token = storage.getItem('_web_token');
      _web_token && (config.headers._web_token = _web_token);
      config.url = '/exam' + config.url;
      config.headers["content-Type"] = 'text/yzedu+;charset=utf-8';
      if (config.url.includes('/upload') || config.url.includes('/authentication/V2') ) return config; //上传文件
      if (config.data === undefined) {
        config.data = {};
      }
      let data = config.data || {}
      data = Base64.encode(JSON.stringify(data));
      config.data = data
    }
    return config
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    let { data } = response;
    try {
      responseCode(data, JSON.parse(Base64.decode(response.config.data) || '{}').body || {});
    } catch (e) {
      responseCode(data, {});
    }
    return data;
  },
  error => {
    Message.error('服务网络有异常，请稍后再试！');
    return Promise.reject(error);
  }
)

let showIndex = 0;
function responseCode(data, fromData) {
  if(data.msg == 'token为空') {
    Message.error('网络异常，请重新登录!')
    setTimeout(() => {
      toLogin();    
    }, 1000);
    return;
  }
  if (data.code === 'E00304') { //登录失效或未登录
    showIndex++;
    if(showIndex > 1) return;
    // MessageBox('检测到您已经登录了远智智能刷题或异地登录，考试过程中请勿查看资料，规范考试过程。请重新登录考试系统进行考试。','系统提示', {
    //   confirmButtonText: '确定',
    // }).then(()=>{
    //   showIndex = 0;  
    //   toLogin();
    // }).catch(error=>{
    //     showIndex = 0;  
    //     toLogin();        
    // }); 
    let msg =  `<p style="font-size: 18px;font-weight: 600;text-align:center;color: #170606;">检测到您已经登录了远智智能刷题或异地登录</p><div style="
      width: 252px;height: 40px;margin:26px auto 60px auto;font-size: 14px;font-weight: 400;text-align:center;color: #170606;">考试过程中请勿查看资料，规范考试过程 请重新登录考试系统进行考试</div>`;
    msgModal.open({
      title:'系统提示',
      msg: msg,
      showClose: false,
      closeESC: false,
      closeESC: false,
      confirm : ()=>{
        showIndex = 0;  
        toLogin();  
      }
    })
  } else if (data.code === 'E0010') { //异地登录错误码
    if (window.history.length === 1) {
      toLogin();
    } else {
      Message.closeAll()
      alert('您的帐号在另一地点登录，您已被迫下线', '重新登录', {
        confirmButtonText: '确定',
        callback: action => {
          toLogin();
        }
      });
    }
  } else if (data.code !== '00' && !fromData.notPrompt) {
    if (data.code) {
      Message.error(data.message || data.msg || data.code)
    }

  }
}

function toLogin() {
  router.push({
    name: 'login',
  });
}

// 全局钩子
router.beforeEach((to, from, next) => {
  document.title = '远智教育-在线考试系统'
  if (!global.dictJson && to.meta.loadDict) {
    const $script = document.createElement('script');
    $script.src = config.dict;
    global.document.body.appendChild($script);
    $script.onload = () => {
      handle(to, from, next);
    }
  } else {
    handle(to, from, next);
  }

})
function handle(to, from, next) {
  if(to.name =='home'){
    if(to.query.web_token) {
      storage.clearAll();
      storage.setItem('_web_token',to.query.web_token);
    }
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!!storage.getItem('stdId') || !!storage.getItem('_web_token')) {
      next();
    } else {
      next({
        name: 'login',
      });
    }
  } else {
    next();
  }
}
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js